import { ErrorApi } from 'api/interfaces';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { languageValues } from './languageUtils';

export const getAxiosError = (error: AxiosError<any, any>): string | null => {
  if (error.response && error.response.data) {
    if (
      Array.isArray(error.response.data.details) &&
      error.response.data.details.length > 0
    ) {
      return error.response.data.details[0].message as string;
    } else {
      return error.response.data.message as string;
    }
  } else {
    if (typeof error.message === 'string') {
      return error.message;
    }
  }
  return null;
};

export default function AxiosErrorHandler(error: AxiosError) {
  const errorMessage: string | null = getAxiosError(error);
  if (typeof errorMessage === 'string') {
    toast.error(languageValues.toasts.error.keyErrors(errorMessage));
  }
}

export const getAxiosErrorApiCode = (
  error: AxiosError<ErrorApi>
): string | number | null => {
  if (error.response && error.response.data) {
    const data: ErrorApi = error.response.data;
    if (data.code) {
      return data.code;
    }
  }
  switch (typeof error.code) {
    case 'string':
    case 'number':
      return error.code;
    default:
      return null;
  }
};
